import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ApolloError } from '@apollo/client';

import { MembershipOfferFragment } from '@occc/graphql';
import { IPaginationProps } from '@occc-app/hooks/usePaginatedQuery';
import { getOfferComponentType } from '@occc-app/offerHelpers/utils';
import { createRouteCreator } from '@occc-app/routes/CampaignComponents/utils';
import { DataTable, DataTableHeader, MakeTableFields, Row } from '@occc/ui-design-system';

type OffersTableProps = {
  offers?: MembershipOfferFragment[];
  loading: boolean;
  error?: ApolloError;
  paginationProps: IPaginationProps;
  headers: DataTableHeader[];
  makeFields: MakeTableFields<MembershipOfferFragment>;
};

const OffersTable: React.FC<OffersTableProps> = (props) => {
  const navigate = useNavigate();
  const { offers, loading, error, paginationProps, headers, makeFields } = props;
  const rows: Row[] | null | undefined = offers?.map((offer) => {
    const fields = makeFields(offer);
    const onClick = () => {
      const offerType = getOfferComponentType(offer);

      if (offerType && offer.campaign) {
        const routeCreator = createRouteCreator(offerType);
        navigate(routeCreator.details(offer.campaign.uuid, offer.id));
      }
    };

    return {
      key: offer.id,
      fields,
      onClick,
    };
  });

  return (
    <DataTable
      headers={headers}
      rows={rows}
      loading={loading}
      error={error}
      paginationProps={paginationProps}
    />
  );
};

export default OffersTable;
